import { PrimaryButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import React from "react";

import cameraIcon from "@/assets/icons/camera.svg";
import emailIcon from "@/assets/icons/email.svg";
import headsetIcon from "@/assets/icons/headset.svg";
import styles from "./SolutionDamagedOnDelivery.module.scss";
// import EmailFormNodeWithoutQuestions from "@/components/email-form-node/EmailFormWithoutQuestions";
// const emailForm = {
//   submitButton: "Send Photos",
//   id: "damagedOnDelivery",
//   subject: "Damaged_On_Delivery",
//   fields: [
//     "FULL_NAME",
//     "POSTCODE",
//     "EMAIL",
//     "PHONE_NUMBER",
//     "ORDER_NUMBER_CR_NUMBER_OPTIONAL",
//     "IMAGE_UPLOAD",
//     "DESCRIPTION"
//   ],
//   imageMessage: "We can help you quicker when you share photos of the product"
// };

const SolutionDamagedOnDelivery = () => {
  // const [showForm, setShowForm] = useState(false);
  // const handleClick = () => {
  //   setShowForm(true);
  // };
  return (
    <div className={styles["container"]}>
      <h1>We're sorry your item arrived damaged</h1>
      <div className={styles["copy-container"]}>
        <p className={styles["email-form__subheading"]}>
          So we can resolve this quickly, please follow these steps before the call.
        </p>
        <div className={styles["steps-container"]}>
          <h2 className={styles["next-steps"]}>Next Steps</h2>

          <div className={styles["step-container"]}>
            <div className={styles["step-icon"]}>
              <img src={cameraIcon.src} alt="camera" />
            </div>
            <p className={styles["copy"]}>Take photos of the damaged item</p>
          </div>
          <div className={styles["step-separator1"]} />
          <div className={styles["step-container"]}>
            <div className={styles["step-icon"]}>
              <img src={emailIcon.src} alt="email" />
            </div>
            <p className={styles["copy"]}>
              Send them to us and tell us what you can about the damage. When you submit your email, you&apos;ll get a
              case reference number.
            </p>
          </div>
          <div className={styles["step-separator2"]} />
          <div className={styles["step-container"]}>
            <div className={styles["step-icon"]}>
              <img src={headsetIcon.src} alt="headset" />
            </div>
            <p className={styles.copy}>Call us and quote your case reference number</p>
          </div>
        </div>
      </div>
      <PrimaryButton
        tag="a"
        href="/customer-services/email-us?t=deliveryQuery-damagedOnDeliveryNonFurniture-online"
        className={styles.cta}
      >
        Send Photos
      </PrimaryButton>
    </div>
  );
  // if showForm
  // return (
  //   <div className={styles["container"]}>
  //     <div className={styles["email-form__container"]}>
  //       <div className={styles["email-form__inner-container"]}>
  //         <h1 className="util-sectionHeading">Email</h1>
  //         <p className={styles["email-form__subheading"]}>
  //           Our Customer Service team are currently experiencing high volumes of emails. Please be assured we will
  //           respond as soon as possible.
  //         </p>
  //         <p className={styles["email-form__subheading"]}>Please provide the following details.</p>
  //
  //   <EmailFormNodeWithoutQuestions
  //           submitButton={emailForm.submitButton}
  //           subject={emailForm.subject}
  //           fields={emailForm.fields}
  //           imageMessage={emailForm.imageMessage}
  //           id={emailForm.id}
  //           source={emailForm.source}
  //         />
  //       </div>
  //     </div>
  //   </div>
  // );
};

export default SolutionDamagedOnDelivery;
